import { Box, Divider, Paper, TextField, Typography } from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const MaterialHIronDetails = ({ isNonMobile, tableValues, setTableValues }) => {
  // console.log("lab test data-", mainData);

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    coatingDesignation: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  useEffect(() => {
    calculateValues();
  }, [
    tableValues.baseThicknessValue,
    tableValues.averageThicknessValue,
    tableValues.totalThicknessValue,
  ]);

  const calculateValues = () => {
    setTableValues((pre) => ({
      ...pre,
      baseThicknessSatisfacory:
        Number(pre.baseThicknessValue === "" ? 0 : pre.baseThicknessValue) >=
        Number(pre.baseThickness)
          ? true
          : false,
      averageThicknessSatisfactory:
        Number(
          pre.averageThicknessValue === "" ? 0 : pre.averageThicknessValue,
        ) >= Number(pre.averageThickness)
          ? true
          : false,
      totalThicknessSatisfacory:
        Number(pre.totalThicknessValue === "" ? 0 : pre.totalThicknessValue) >=
        Number(pre.totalThickness)
          ? true
          : false,
    }));
  };

  return (
    <Box justifyItems="center">
      <Paper variant="elevation" elevation={2} sx={{ padding: "20px" }}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <img src="/assets/hiron.jpg" alt="Description of image" />
        </Box>
        <Divider sx={{ margin: "5px 0" }} />
        <Box
          display="grid"
          gap={0.5}
          alignItems="center"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 4",
            },
          }}
        >
          <Typography
            variant="h5"
            sx={{ gridColumn: "span 2" }}
            color="success"
            textAlign="center"
          >
            DIMENSIONS
          </Typography>

          <Typography
            variant="h5"
            sx={{ gridColumn: "span 2" }}
            color="success"
            textAlign="center"
          >
            ENTER DATA
          </Typography>

          <Divider sx={{ gridColumn: "span 4", marginBottom: "10px" }} />
          <Typography
            variant="h4"
            color="info"
            textAlign="start"
            sx={{ gridColumn: "span 2" }}
          >
            1. b (mm)
          </Typography>
          <TextField
            value={tableValues.baseThickness}
            fullWidth
            variant="outlined"
            label="b(mm) value"
            onChange={(e) => {
              setTableValues((pre) => ({
                ...pre,
                baseThickness: e.target.value,
              }));
            }}
            type="number"
            size="small"
            sx={{
              gridColumn: "span 2",
              "& input": {
                textAlign: "right",
              },
            }}
          />

          <Typography
            variant="h4"
            color="info"
            textAlign="start"
            sx={{ gridColumn: "span 2" }}
          >
            2. h (mm)
          </Typography>
          <TextField
            value={tableValues.averageThickness}
            fullWidth
            variant="outlined"
            label="h(mm) value"
            onChange={(e) =>
              setTableValues((pre) => ({
                ...pre,
                averageThickness: e.target.value,
              }))
            }
            type="number"
            size="small"
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
              "& input": {
                textAlign: "right",
              },
            }}
          />
          <Typography
            variant="h4"
            color="info"
            textAlign="start"
            sx={{ gridColumn: "span 2" }}
          >
            3. t2 (mm)
          </Typography>

          <TextField
            value={tableValues.totalThickness}
            fullWidth
            variant="outlined"
            label="t2(mm) value"
            type="number"
            size="small"
            onChange={(e) =>
              setTableValues((pre) => ({
                ...pre,
                totalThickness: e.target.value,
              }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",

              "& input": {
                textAlign: "right",
              },
            }}
          />
          <Typography
            variant="h4"
            color="info"
            textAlign="start"
            sx={{ gridColumn: "span 2" }}
          >
            4. t1 (mm)
          </Typography>

          <TextField
            value={tableValues.baseThicknessValue}
            fullWidth
            variant="outlined"
            label="t1(mm) value"
            type="number"
            size="small"
            onChange={(e) =>
              setTableValues((pre) => ({
                ...pre,
                baseThicknessValue: e.target.value,
              }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",

              "& input": {
                textAlign: "right",
              },
            }}
          />

          <Typography
            variant="h4"
            color="info"
            textAlign="start"
            sx={{ gridColumn: "span 2" }}
          >
            5. Unight Weight (Kg/m)
          </Typography>

          <TextField
            value={tableValues.averageThicknessValue}
            fullWidth
            variant="outlined"
            label="Unight Weight (Kg/m)"
            type="number"
            size="small"
            onChange={(e) =>
              setTableValues((pre) => ({
                ...pre,
                averageThicknessValue: e.target.value,
              }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",

              "& input": {
                textAlign: "right",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default MaterialHIronDetails;
